export const PROFILE_TABLE = 'profiles';
export const PROFILE_PUBLIC_TABLE = 'profile_public_view';
export const PROFILE_PUBLIC_CARD_TABLE = 'profile_public_card_view';
export const PROFILE_PUBLIC_HIDDEN_TABLE = 'profile_public_hidden_view';
